module.exports = __webpack_public_path__ + "img/ico-07.c4ac0be5.png";